/**
 * Language switcher component - Toggle between Spanish and English
 */
import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-ink-muted bg-surface-2 rounded-lg hover:bg-surface-3 transition-colors"
      title={t('profile.form.language')}
    >
      <span className="text-lg">🌐</span>
      <span className="hidden sm:inline">
        {i18n.language === 'es' ? 'ES' : 'EN'}
      </span>
    </button>
  );
}
